export const PLACEMENT_TEST_TYPE = {
  LEVEL_DETERMINATION: 'LEVEL_DETERMINATION',
} as const;

export type PlacementTestTypeValue =
  (typeof PLACEMENT_TEST_TYPE)[keyof typeof PLACEMENT_TEST_TYPE];

export const LEVEL_DETERMINATION_ALLOWED_QUESTION_TYPES = [
  'FREE_TEXT_ONLY_PRONUNCIATION',
  'TRANSCRIBE_AND_SCORE',
  'DESCRIBE_IMAGE',
  'READ_SENTENCE',
  'MISSING_WORD',
  'MISSING_LETTERS',
] as const;

export const isLevelDeterminationPlacementTest = (type?: string) =>
  type === PLACEMENT_TEST_TYPE.LEVEL_DETERMINATION;

export const isQuestionTypeAllowedForLevelDetermination = (
  questionType?: string,
) =>
  Boolean(
    questionType &&
    (LEVEL_DETERMINATION_ALLOWED_QUESTION_TYPES as readonly string[]).includes(
      questionType,
    ),
  );

export const getLevelDeterminationAllowedQuestionTypesText = () =>
  LEVEL_DETERMINATION_ALLOWED_QUESTION_TYPES.join(', ');
